<h1 mat-dialog-title>Delete output formula</h1>
<mat-dialog-content class="dialog-body">
  <p>
    Delete <strong>{{ data.current.name }}</strong>?
  </p>

  @if (probed) {
    @if (needsAcknowledge && warning !== null) {
      <div class="warning">
        <p class="warning-line">
          This output formula is referenced by <strong>{{ warning.count }}</strong>
          outputs {{ warning.count === 1 ? 'collection' : 'collections' }}.
        </p>
        @if (warning.names.length > 0) {
          <ul class="names-list">
            @for (n of warning.names; track n) {
              <li>{{ n }}</li>
            }
          </ul>
        }
        <mat-checkbox [formControl]="acknowledgeControl">
          I understand this will affect {{ warning.count }}
          {{ warning.count === 1 ? 'item' : 'items' }}
        </mat-checkbox>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="warn"
    [disabled]="!canDelete"
    (click)="confirm()"
  >
    Delete
  </button>
</mat-dialog-actions>
